<template>
  <AppSection
    id="monitoring-jobs"
    type="section"
    :title="$getConst.pages.connectivity_test.last_jobs"
  >
      <b-table
        :items="jobs"
        :fields="fields"
        :busy="isLoading"
        show-empty
        fixed
        responsive="md"
        table-class="text-center"
        thead-class="text-center"
      >
        <template #table-busy>
          <AppSpinner
            class="mx-auto my-2 text-secondary"
            size="4"
          />
        </template>

        <template #cell(jobs)="data">
          <div class="text-center">
            <i :class="[$getConst.icons.check, 'text-success  fa-2x']"/>
          </div>
        </template>

        <template #cell(properties)="data">
          <b-link @click="showPropertiesDetails(data.item)" v-b-tooltip.hover
                    :title="$t($getConst.pages.button.show_more)"><i :class="$getConst.icons.externalLink + ' text-primary'"></i></b-link>
        </template>

        <template #cell(details)="data">
          <template v-if="data.item.details !== null">
            <b-link @click="showDetails(data.item)" v-b-tooltip.hover
                    :title="$t($getConst.pages.button.show_more)"><i :class="$getConst.icons.externalLink + ' text-primary'"></i></b-link>
          </template>
        </template>

      </b-table>
      <ShowLogDetailsModal v-if="log" :log="log" :id="detailsModal" size="xl"></ShowLogDetailsModal>
      <ShowLogPropertiesDetailsModal v-if="log" :log="log" :id="propertiesDetailsModal" size="xl"></ShowLogPropertiesDetailsModal>
  </AppSection>
</template>

<script>
  import {monitoringJobs} from "../../../../api/scopes.api";
  import AppSpinner from "../../../../components/common/utils/AppSpinner";
  import AppSection from "../../../../components/common/sections/AppSection";
  import ShowLogDetailsModal from "../scope_logs/ShowLogDetailsModal";
  import ShowLogPropertiesDetailsModal from "../scope_logs/ShowLogPropertiesDetailsModal";

  export default {
    name: "jobsMonitoring",
    components: {ShowLogPropertiesDetailsModal, ShowLogDetailsModal, AppSpinner, AppSection},
    props: {
      scope_id: null
    },
    data() {
      return {
        isLoading: false,
        jobs: null,
        fields: [
          {
            key: 'created_at',
            label: this.$t(this.$getConst.pages.nav_status_history.nav_status_test_date),
            formatter: (value, key, item) => {
              const date = new Date(value);
              return date.toLocaleString()
            },
          },
          { key: 'log_name' },
          { key: 'description'},
          { key: 'properties'},
          { key: 'status'},
          { key: 'details'},
          { key: 'diffMinutes', label:'executed since'},
        ],
        log: null,
        detailsModal: 'details-modal',
        propertiesDetailsModal: 'properties-details-modal'
      }
    },
    methods: {
      monitoringJobs() {
        this.isLoading = true;
        monitoringJobs(this.scope_id).then(
          (response) => {
            this.jobs = response.data;
            this.isLoading = false;
          },
          () => {
            this.isLoading = false;
            this.$snotify.error(this.$t(this.$getConst.pages.alerts.unknown_error));
          }
        )
      },
      showDetails(log) {
        this.log = log;
        this.$nextTick(() => this.$bvModal.show(this.detailsModal));
      },
      showPropertiesDetails(log) {
        this.log = log;
        this.$nextTick(() => this.$bvModal.show(this.propertiesDetailsModal));
      },
    },
    created() {
      this.monitoringJobs();
    }
  }
</script>

<style scoped>

</style>
